// extracted by mini-css-extract-plugin
module.exports = {"background":"AuthLayout_background__1EPqf"};